import { isEmpty } from 'ramda'
import { useEffect } from 'react'

import { Table, Td, TdLabel, Th, ThLabel, TrSelectable, useSelectionStateContext } from 'app/common/ui-components/table'
import { useSaleTypesAsArray } from 'app/dataProviders/SaleTypesData'
import PlainCheckbox from 'app/common/ui-next/plain-checkbox'
import { SkeletonLoadingTBody } from 'app/common/templates-next/page-template'
import { SingleProdictionIcons } from './components'


type Props = {
  disabled?: boolean
}

export const ProductionTypesTable = ({ disabled }: Props) => {
  const { saleTypes, loading } = useSaleTypesAsArray({ sort: 'byTitle' })
  const { selection, allSelected, init, update, updateAll } = useSelectionStateContext()
  const isAllReserved = isEmpty(selection) && !loading

  useEffect(() => {
    if (!isEmpty(saleTypes)) {
      init(
        saleTypes
          .filter(({ reserved }) => !reserved)
          .map(({ id }) => id),
      )
    }
  }, [saleTypes, init])

  return (
    <Table wide>
      <thead>
        <TrSelectable
          id="all"
          onClick={(_, state) => updateAll(state)}
          selected={allSelected}
          header
        >
          {checkboxProps => (
            <>
              <ThLabel htmlFor="all" width={50} alignLeft>
                <PlainCheckbox
                  label="Выбрать все"
                  skipLabel
                  {...checkboxProps}
                  disabled={disabled || isAllReserved}
                />
              </ThLabel>
              <Th alignLeft>{'Наименование'}</Th>
              <Th>{''}</Th>
            </>
          )}
        </TrSelectable>
      </thead>
      <tbody>
        {loading && <SkeletonLoadingTBody rows={7} columns={3} onlyRows />}
        {!loading && saleTypes.map(({ id, title, reserved }) => (
          <TrSelectable
            key={id}
            id={id}
            onClick={update}
            selected={selection[id]}
            disabled={disabled}
          >
            {checkboxProps => (
              <>
                <TdLabel htmlFor={id} width={50} alignLeft>
                  <PlainCheckbox
                    name={id}
                    id={id}
                    label={title}
                    skipLabel
                    {...checkboxProps}
                    disabled={disabled || reserved}
                  />
                </TdLabel>
                <TdLabel htmlFor={id} alignLeft>
                  {title}
                </TdLabel>
                <Td alignRight>
                  {!reserved && <SingleProdictionIcons saleTypeId={id} />}
                </Td>
              </>
            )}
          </TrSelectable>
        ))}
      </tbody>
    </Table>
  )
}
